// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ky-0";
export var fileCarousel = "_ky-2";
export var removeFileButton = "_ky-1";